<template>
  <v-container grid-list-xs fluid>
    <v-row>
      <v-col cols="12">



              <div class="card-header">Dashboard</div>
              <div class="card-body">
                <div v-if="user" class="alert alert-success" role="alert">You are logged in!</div>
                <a>logout</a>
                <v-btn @click="signOut()">Logout</v-btn>
                <v-btn @click="creaStruttura('struttura prova',apikeyhr)">Crea Struttura</v-btn>
                <v-text-field
                  label="APIKEY HR"

                  v-model="apikeyhr"></v-text-field>
              </div>
              <struttura @refreshstruttura="aggiornaStruttura($event)"></struttura>



      </v-col>


    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import firebase from "firebase";
import Struttura from "@/components/Struttura.vue";


export default {
  components:{
    struttura:Struttura
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user"
    }),

  },
  mounted(){
    this.apikeyhr = this.apikey;
  },
  methods: {
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({
            name: "home"
          });
        });
    },
    get_cur_user(){
       return firebase.auth().currentUser
    },
    aggiornaStruttura(apikey){
      console.log("aggiorno", apikey)
      this.creaStruttura("",apikey);
    },
    creaStruttura(descr,apikeyhr){
      let me = this
      this.$store.dispatch('getStrutturaHR',apikeyhr).then(result=>{
        console.log(result)
        if(result.data.RISPOSTAOK ==-1){
          result.data.RISULTATOJSON.data.idcliente = firebase.auth().currentUser.uid
          result.data.RISULTATOJSON.data.id = result.data.RISULTATOJSON.data.guidstrutturahr
          result.data.RISULTATOJSON.data.apikeyhr = apikeyhr
          me.$store.dispatch('strutture/set', result.data.RISULTATOJSON.data).catch(err=>{
            console.log(err)
            alert(err)
          })
        }else
        {
          alert(result)
        }
        
        
      })
      .catch(err=>{
        alert(err)
      })
/*
      const db = this.$firebase.firestore();
      const struttura ={
          idcliente : firebase.auth().currentUser.uid,
          guidhr: guidhr,
          descrizione: descr,
          testi:[
                  {id:uuid.v1(),tipo:'info',titolo:"titolo",testo:"scrivi qui"},
                  {id:uuid.v1(),tipo:'info',titolo:"titolo2",testo:"scrivi qui"}
                 ],
          gallerie:[
            {
              id:uuid.v1(),
              titolo:'immagini hotel',
              immagini:[
                {id:uuid.v1(),titolo:'foto panoramica',src:'https://picsum.photos/500/300?image=48'},
                {id:uuid.v1(),titolo:'foto panoramica',src:'https://picsum.photos/500/300?image=74'},
                {id:uuid.v1(),titolo:'foto panoramica',src:'https://picsum.photos/500/300?image=4'},
                ]
            },
            {
              id:uuid.v1(),
              titolo:'immagini camera',
              immagini:[
                {id:uuid.v1(),titolo:'foto panoramica',src:'https://picsum.photos/500/300?image=48'},
                {id:uuid.v1(),titolo:'foto panoramica',src:'https://picsum.photos/500/300?image=74'},
                {id:uuid.v1(),titolo:'foto panoramica',src:'https://picsum.photos/500/300?image=4'},
                ]
            }
                ],
          anagrafica:{
            ragionesociale:'',
            indirizzo:'',
            citta:'',
            facebook:'',
            instagram:'',
            skype:'',
            whatsapp:''
          }
      }
      db.collection("strutture")
          .add(struttura);
          */

    },
  },
  data() {
    return {
      guidhr:'',
      apikeyhr: null
    };
  },

};
</script>